// extracted by mini-css-extract-plugin
module.exports = {"profile":"LandlordProfile_profile__5Y8lh","badge":"LandlordProfile_badge__kal_N","checkIcon":"LandlordProfile_checkIcon__pafsN","status":"LandlordProfile_status___CzI5"};